import { Injectable } from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  private readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const parts = value.split(this.DELIMITER);
      return {
        day: parseInt(parts[0], 10),
        month: parseInt(parts[1], 10),
        year: parseInt(parts[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? `${String(date.day).padStart(2, '0')}${this.DELIMITER}${String(
          date.month
        ).padStart(2, '0')}${this.DELIMITER}${date.year}`
      : '';
  }
}
